import { useEffect } from 'react';
import { NAME } from '@cs/state/constants';
import {
  createTenantSchema,
  ModalCreateTenantProps,
  Tenant,
} from '@cs/state/model';
import { FlexContainer, Input, Label } from '@facephi/ui-react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ModalCreateTenantStyles } from './Styles';

export const ModalCreateTenant = ({
  className,
  onSave,
  onChangeShow,
  show,
}: ModalCreateTenantProps) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(createTenantSchema),
    mode: 'onChange',
  });

  const onSubmit = (newTenant: Tenant) => {
    if (newTenant) {
      onSave(newTenant);
    }
  };

  useEffect(() => {
    if (show) {
      reset({});
    }
  }, [show]);

  return (
    <ModalCreateTenantStyles
      show={show}
      testId="modal-create-tenant"
      onChangeShow={onChangeShow}
      header={{
        iconName: 'PlusCircle',
        title: t('Create a new tenant'),
      }}
      footer={{
        closeButtonLabel: t('Cancel'),
        submitButtonLabel: t('Save'),
        onSubmitButton: handleSubmit(onSubmit),
      }}
      overlayBlur
      className={className}
      hasPadding
    >
      <FlexContainer
        as="form"
        id="form"
        flexDirection="column"
        rowGap="1.6"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Label fontSize="14" htmlFor="name">
          {t('Name')}
        </Label>

        <Input
          testId="tenant-input-name"
          autoFocus
          id="name"
          {...register(NAME)}
          errorLabel={errors.name?.message && t(errors.name.message)}
        />
      </FlexContainer>
    </ModalCreateTenantStyles>
  );
};
